export default class Garnish {
  constructor(wrapper) {
    this.garnishEntity = $(wrapper);
    this.price = null;
    this.oldPrice = null;
    this.weight = null;
    this.selector = null;
    this.success = null;
    this.apply = null;
    this.incart = null;
    this.radioChoosen = null;
    this.cottageButtonsBlock = null;
    this.bigButton = null;
    this.multySelect = null;
    this.select = null;
    this.init();
  }

  init() {
    this.price = this.garnishEntity.find('[data-entity="price"]');
    this.weight = this.garnishEntity.find('[data-entity="weight"]');
    this.selector = this.garnishEntity.find('[data-action="change-size"]');
    this.success = this.garnishEntity.find('[data-entity="success"]');
    this.apply = this.garnishEntity.find('[data-action="apply"]');
    this.apply.unbind();
    this.incart = this.garnishEntity.find('[data-entity="incart-garnish"]');
    this.radioChoosen = this.garnishEntity.find('[data-action="change-size"]:checked');
    this.oldPrice = this.garnishEntity.find('[data-entity="oldprice"]');
    this.apply.on("click", this.addToCart.bind(this));
    this.selector.on("click", this.onSelectorChange.bind(this));
    this.bigButton = this.garnishEntity.find("[data-button='true']");
    this.cottageButtonsBlock = this.garnishEntity.find("[data-entity='plus-minus']");

    if (this.garnishEntity.find('.garnish__container').length !== 0) {
      this.multySelect = true;
      this.selector.on("change", this.onSelectorChange.bind(this));
      this.select = this.garnishEntity.find('select');
      this.radioChoosen = this.select.find(':selected');
      this.select.on('change', function () {
      })
    }
  }

  onSelectorChange(e) {
    let self = this;
    this.radioChoosen = $(e.target);
    if (this.multySelect) {
      this.radioChoosen = this.radioChoosen.find(':selected');
    }
    if (this.radioChoosen.data('incart') >= 1) {
      this.showCottageButtons();
    } else {
      this.showBigButton();
    }

    this.price.text(this.radioChoosen.data('price'));
    this.oldPrice.text(this.radioChoosen.data('oldprice'));
    this.weight.text(this.radioChoosen.data('weight'));
    this.incart.text(this.radioChoosen.data('incart'));

  }

  addToCart(e) {
    e.preventDefault();
    e.stopPropagation();
    let initiator = $(e.target);
    let formAction = 'add';
    let isAdd = initiator.data('entity') === 'add';
    if (!isAdd) {
      /** ничо не делаем */
      if (this.radioChoosen.data('incart') < 1) {
        return false;
      }
      formAction = 'delete_one';
    }


    if (this.radioChoosen.data('incart') < 2 && formAction === 'delete_one') {
      this.showBigButton();
    } else {
      this.showCottageButtons();
    }

    let data = new FormData();
    let self = this;
    data.append('action', formAction);
    data.append('id', this.radioChoosen.val());
    data.append('quantity', 1);
    data.append('garnish', true);
    data.append('date', window.catalogFilterDate);
    data.append('size', this.radioChoosen.data('size'));

    $.ajax({
      method: 'POST',
      url: '/ajax/basketItem.php',
      data: data,
      cache: false,
      contentType: false,
      processData: false,
      dataType: 'json',
      success: function (result) {
        if (isAdd) {
          self.radioChoosen.data('incart', self.radioChoosen.data('incart') + 1);
        } else {
          self.radioChoosen.data('incart', self.radioChoosen.data('incart') - 1);
        }
        self.incart.text(self.radioChoosen.data('incart'));
        window.reloadBasket(undefined, undefined, true);
      },
      error: function (data) {
        console.log(data.responseText);
      }
    });
    return true;
  }

  isAvalableToAdd() {
    return true;
  }

  delete() {
    let data = new FormData();
    data.append('action', 'delete');
    data.append('id', this.choise.val());
    data.append('quantity', 1);
    data.append('date', window.catalogFilterDate);
    let self = this;
    $.ajax({
      method: 'POST',
      url: '/ajax/basketItem.php',
      data: data,
      cache: false,
      contentType: false,
      processData: false,
      dataType: 'json',
      success: function (result) {
        self.selector[0].click();
        self.success.addClass('hide');
        self.apply.removeClass('hide');
      },
      error: function (data) {
        console.log(data.responseText);
      }
    })
  }

  showBigButton() {
    let self = this;
    if (this.cottageButtonsBlock.css('display') !== 'none') {
      this.cottageButtonsBlock.fadeOut(200, function () {
        self.incart.text(self.radioChoosen.data('incart'));
        self.bigButton.fadeIn(200);
      });
    }

  }

  showCottageButtons() {
    let self = this;
    if (this.bigButton.css('display') !== 'none') {
      self.incart.text(self.radioChoosen.data('incart'));
      this.bigButton.fadeOut(200, function () {
        self.cottageButtonsBlock.fadeIn(200);
      });
    }
  }

  multySelectInit() {

  }
}
